import { createSlice } from '@reduxjs/toolkit';

import {
  alternarStatusModeloComunicacao,
  atualizarModeloComunicacao,
  buscarModeloComunicacao,
  criarModeloComunicacao,
  listarModelosComunicacao,
  listarModelosDocumentoAnexo,
} from './actions';
import type { ModeloComunicacao, ModelosComunicacaoState } from '../types/modeloComunicacaoTypes';

const initialState: ModelosComunicacaoState = {
  modelos: [],
  modelosDocumento: [],
  isLoading: false,
  isSaving: false,
  error: null,
};

const upsert = (state: ModelosComunicacaoState, modelo: ModeloComunicacao) => {
  const index = state.modelos.findIndex((item) => item.id === modelo.id);
  if (index !== -1) {
    state.modelos[index] = modelo;
  } else {
    state.modelos.push(modelo);
  }
};

const modelosComunicacaoSlice = createSlice({
  name: 'modelosComunicacao',
  initialState,
  reducers: {
    clearModelosComunicacaoError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarModelosComunicacao.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarModelosComunicacao.fulfilled, (state, action) => {
        state.isLoading = false;
        state.modelos = action.payload;
      })
      .addCase(listarModelosComunicacao.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload ?? 'Erro ao carregar os modelos.';
      })

      .addCase(listarModelosDocumentoAnexo.fulfilled, (state, action) => {
        state.modelosDocumento = action.payload;
      })
      .addCase(listarModelosDocumentoAnexo.rejected, (state, action) => {
        state.modelosDocumento = [];
        state.error = action.payload ?? 'Erro ao carregar os modelos de documento.';
      })

      .addCase(buscarModeloComunicacao.fulfilled, (state, action) => {
        upsert(state, action.payload);
      })
      .addCase(buscarModeloComunicacao.rejected, (state, action) => {
        state.error = action.payload ?? 'Erro ao carregar o modelo.';
      })

      .addCase(criarModeloComunicacao.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(criarModeloComunicacao.fulfilled, (state, action) => {
        state.isSaving = false;
        upsert(state, action.payload);
      })
      .addCase(criarModeloComunicacao.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload ?? 'Erro ao criar o modelo.';
      })

      .addCase(atualizarModeloComunicacao.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(atualizarModeloComunicacao.fulfilled, (state, action) => {
        state.isSaving = false;
        upsert(state, action.payload);
      })
      .addCase(atualizarModeloComunicacao.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload ?? 'Erro ao salvar o modelo.';
      })

      .addCase(alternarStatusModeloComunicacao.fulfilled, (state, action) => {
        upsert(state, action.payload);
      })
      .addCase(alternarStatusModeloComunicacao.rejected, (state, action) => {
        state.error = action.payload ?? 'Erro ao atualizar o status.';
      });
  },
});

export const { clearModelosComunicacaoError } = modelosComunicacaoSlice.actions;

export default modelosComunicacaoSlice.reducer;
